// extracted by mini-css-extract-plugin
module.exports = {"dummy":"styles_dummy__gJl-A","dummy_top":"styles_dummy_top__1ZCRo","dummy_bottom":"styles_dummy_bottom__3pfrt"};